export const enum Modules {
  CUSTOM_DATA = 'CUSTOM_DATA',
  COLLABORATION = 'COLLABORATION',
  QUINYX = 'QUINYX',
  RECRUITING_MINI = 'RECRUITING_MINI',
  MEPCO = 'MEPCO',
  SOLAINTEL = 'SOLAINTEL',
  CORE = 'CORE',
  DEVELOPMENT = 'DEVELOPMENT',
  BONUS_CALC = 'BONUS_CALC',
  UI2 = 'UI2',
  ANALYTICS = 'ANALYTICS',
  RECRUITING_FULL = 'RECRUITING_FULL',
  PEOPLE = 'PEOPLE',
  ORGANISATION = 'ORGANISATION',
  EXPERIMENTAL = 'EXPERIMENTAL',
  PLANNING = 'PLANNING',
  WORK_TIME_REPORTING = 'WORK_TIME_REPORTING',
  SOLAPULSE = 'SOLAPULSE',
  PERFORMANCE = 'PERFORMANCE',
  REWARDING = 'REWARDING',
  WORKSPACE = 'WORKSPACE',
  BRANDING = 'BRANDING',
}
